module.exports = __webpack_public_path__ + "static/img/cont48 (2).a975355.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont48 (2).jpg
// module id = ldQY
// module chunks = 0